import * as React from 'react';

import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from '@mui/material/AccordionSummary';

import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  backgroundColor: '#f2f2f2',
  '&::before': {
    display: 'none',
    borderTop: 'none',
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper': {
    marginLeft: 'auto', // Align the expand icon to the right
    transform: 'rotate(0deg)', // Initial rotation
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
}));

export default function BrokerAsyncAccordions() {
  // State for each individual panel
  const [isPanel1Open, setPanel1Open] = React.useState(false); // First panel open by default

  // Handler to toggle each panel
  const handleChangePanel1 = (
    event: React.SyntheticEvent,
    newExpanded: boolean
  ) => {
    setPanel1Open(newExpanded);
  };

  return (
    <div style={{ width: '100%' }}>
      <Accordion expanded={isPanel1Open} onChange={handleChangePanel1}>
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <Typography className="title">
            Find Brokerage with AgentSync
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>agentsync comes here</Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
